import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'GetStartedPage.title',
    defaultMessage: 'Access and withdraw your Commerce balance',
    description: 'title of landing page',
  },
  description: {
    id: 'GetStartedPage.description',
    defaultMessage:
      'We’ll help you move your Commerce funds into a wallet or Coinbase account of your choice. You will no longer need to manage your funds with your Commerce wallet.',
    description: 'descriptive text under title',
  },
  button: {
    id: 'GetStartedPage.button',
    defaultMessage: 'Get started',
    description: 'button text for call to action',
  },
});
